/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Work_TitleInputs */

const en_home_work_title = /** @type {(inputs: Home_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See what you could hand over.`)
};

const lv_home_work_title = /** @type {(inputs: Home_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatiet, ko varētu nodot sistēmai.`)
};

/**
* | output |
* | --- |
* | "See what you could hand over." |
*
* @param {Home_Work_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_work_title = /** @type {((inputs?: Home_Work_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Work_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_work_title(inputs)
	return en_home_work_title(inputs)
});